import { useState, type ChangeEvent } from 'react';
import { Calendar, DollarSign, User } from 'lucide-react';
import type { NuevoPagoDraft, Pago } from '../../types';

interface Props {
  editando: Pago | null;
  onGuardar: (draft: NuevoPagoDraft) => void;
  onCancelar: () => void;
}

export function FormularioPago({ editando, onGuardar, onCancelar }: Props) {
  const [destinatario, setDestinatario] = useState(editando?.destinatario ?? '');
  const [monto, setMonto] = useState(editando ? String(editando.monto) : '');
  const [fechaLimite, setFechaLimite] = useState(editando?.fechaLimite ?? '');

  const guardar = () => {
    const montoNum = parseFloat(monto);
    if (!destinatario.trim()) {
      alert('Por favor escribe el destinatario');
      return;
    }
    if (!Number.isFinite(montoNum) || montoNum <= 0) {
      alert('Por favor ingresa un monto válido');
      return;
    }
    if (!fechaLimite) {
      alert('Por favor selecciona la fecha límite');
      return;
    }
    onGuardar({ destinatario: destinatario.trim(), monto: montoNum, fechaLimite });
  };

  return (
    <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
      <h2 className="text-xl font-bold text-gray-800 mb-4">
        {editando ? '✏️ Editar Pago' : 'Nuevo Pago Pendiente'}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <User size={16} className="inline mr-1" />
            Destinatario *
          </label>
          <input
            type="text"
            value={destinatario}
            onChange={(e: ChangeEvent<HTMLInputElement>) => setDestinatario(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
            placeholder="¿A quién le pagas?"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <DollarSign size={16} className="inline mr-1" />
            Monto *
          </label>
          <input
            type="number"
            inputMode="decimal"
            min="0"
            step="0.01"
            value={monto}
            onChange={(e: ChangeEvent<HTMLInputElement>) => setMonto(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
            placeholder="0.00"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <Calendar size={16} className="inline mr-1" />
            Fecha límite *
          </label>
          <input
            type="date"
            value={fechaLimite}
            onChange={(e: ChangeEvent<HTMLInputElement>) => setFechaLimite(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
          />
        </div>
      </div>
      <div className="flex gap-3 mt-6">
        <button
          onClick={guardar}
          className="flex-1 bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-3 rounded-lg font-medium transition-colors"
        >
          {editando ? 'Guardar Cambios' : 'Guardar Pago'}
        </button>
        <button
          onClick={onCancelar}
          className="px-6 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
        >
          Cancelar
        </button>
      </div>
    </div>
  );
}
